import { AppSettings } from '@/AppSettings';
import Icon from '@/components/layouts/Icon/Icon';
import { Zoom, buttonClasses } from '@mui/material';
import { ThemeOptions } from '@mui/material/styles';

const DefaultThemeOptions: ThemeOptions = {
    typography: {
        h1: {
            fontWeight: 300,
            fontSize: '2rem',
        },
        h2: {
            fontSize: '1.5rem'
        },
        h3: {
            fontSize: '1.25rem'
        },
        h4: {
            fontSize: '1.20rem'
        },
        h5: {
            fontSize: '1.15rem'
        },
        h6: {
            fontSize: '1.10rem'
        }
    },
    components: {
        MuiAlert: {
            defaultProps: {
                iconMapping: {
                    error: <Icon icon={AppSettings.icons.alertError} />,
                    warning: <Icon icon={AppSettings.icons.alertWarning} />,
                    success: <Icon icon={AppSettings.icons.alertSuccess} />,
                    info: <Icon icon={AppSettings.icons.alertInformation} />
                }
            },
            styleOverrides: {
                icon: {
                    fontSize: '1.5rem'
                },
                action: {
                    [`& .${buttonClasses.root}`]: {
                        minWidth: 0
                    },
                    [`& .${buttonClasses.startIcon} svg`]: {
                        fontSize: '1.5rem'
                    }
                }
            }
        },
        MuiTooltip: {
            defaultProps: {
                TransitionComponent: Zoom
            }
        }
    }
};

export default DefaultThemeOptions;